const activationDirection = "data-activation-direction";
export {
  activationDirection
};
//# sourceMappingURL=TabsRootDataAttributes.js.map
